<mat-card appearance="outlined" [formGroup]="formGroup">
  <mat-card-header>
    <mat-card-title>Loan Details</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <!-- Loan Purposes -->
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>
          <div class="row">
            <div class="col-sm-12">
              <strong>Loan Purposes</strong>
              <button mat-icon-button color="primary" type="button" (click)="addOne('purpose')">
                <i class="material-icons">add_circle_outline</i>
              </button>
            </div>
          </div>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="row">
          <div class="col-sm-3">
            <mat-form-field appearance="outline">
              <mat-label>Purpose</mat-label>
              <mat-select placeholder="Purpose" formControlName="primaryPurpose" (selectionChange)="setPurposesForInvSmsf($event.value)">
                <mat-option *ngFor="let type of primaryPurposeTypes;"
                [disabled]="isSMSF && !type.ext.isSMSF"
                [value]="type.id">{{type.text}}</mat-option>
              </mat-select>
              <mat-error>
                This is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div *ngFor="let purpose of purposesFormArray.controls; index as i">
          <div class="row" [formGroup]="purpose">
            <div class="col-sm-3">
              <mat-form-field appearance="outline">
                <mat-label>Purpose</mat-label>
                <mat-select placeholder="Purpose" formControlName="purpose" (selectionChange)="handleDisbursementPurposeChange(i, $event.value)">
                  <mat-option
                  [disabled]="isSMSF && !type.ext.isSMSF"
                  *ngFor="let type of filteredDisbursementPurposes"
                  [value]="type.id">{{type.text}}</mat-option>
                </mat-select>
                <mat-error>
                  This is required
                  <!-- <app-validation-partial
                    [formGroup]="formGroup"
                    [fieldName]="purpose"
                  ></app-validation-partial> -->
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field appearance="outline" *ngIf="checkDescriptionType(purpose) === 'description'">
                <mat-label>Description</mat-label>
                <input matInput placeholder="Description" formControlName="description">
              </mat-form-field>

              <ng-container *ngIf="checkDescriptionType(purpose) === 'credit-provider'">
                <mat-form-field appearance="outline">
                  <mat-label>Select a lender</mat-label>
                  <mat-select panelClass="full-width" placeholder="Select a lender" formControlName="creditProvider">
                    <mat-option [value]="null">--- Not in list ---</mat-option>
                    <mat-option *ngFor="let lender of allLenders" [value]="lender.partyRoleId">{{lender.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>

              <ng-container *ngIf="checkDescriptionType(purpose) === 'address'">
                <fmc-address-search
                  [required]="addressesRequired"
                  [mode]="'external'"
                  [allowPOBox]="false"
                  [parentFormGroup]="purpose"
                  [controlName]="'address'"
                  [placeholderText]="'Address'"
                  [allowTba]="purpose.value.purpose === 'purchase'"
                  [toggleResetFormValues]="false"
                ></fmc-address-search>
              </ng-container>
            </div>
            <div class="col-3">
              <mat-form-field appearance="outline" *ngIf="checkDetailType(purpose) === 'number'">
                <mat-label>Detail</mat-label>
                <input matInput matTooltip="Enter Account Number" type="number" [matTooltipDisabled]="flagPurposeTooltip(purpose)" placeholder="Detail" formControlName="details">
                <mat-error>Please only enter numbers</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" *ngIf="checkDetailType(purpose) === 'text'">
                <mat-label>Detail</mat-label>
                <input matInput type="text" placeholder="Detail" formControlName="details">
              </mat-form-field>
            </div>
            <div class="col-sm-2">
              <mat-form-field appearance="outline" class="text-end">
                <mat-label>Amount</mat-label>
                <input matInput matInputCommified placeholder="Amount" formControlName="amount">
                <span matPrefix>$&nbsp;</span>
                <mat-error>
                  <ng-container *ngIf="purpose.get('amount').hasError('min')">Amount must be more than $1</ng-container>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-1" *ngIf="i > 0">
              <button mat-icon-button class="button-absolute-right" type="button" (click)="removeOne('purpose', i)" color="warn">
                <i class="material-icons">remove_circle</i>
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-8"></div>
          <div class="col-sm-3">
            <mat-form-field appearance="outline" class="text-end">
              <mat-label>Subtotal</mat-label>
              <input matInput matInputCommified placeholder="Subtotal" formControlName="purposesSubTotal" readonly>
              <span matPrefix>$&nbsp;</span>
              <mat-error *ngIf="formGroup.get('purposesSubTotal').hasError('min')">Loan amount must be greater than current total</mat-error>
            </mat-form-field>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Fees -->
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>
          <div class="row">
            <div class="col-sm-12">
              <strong>Fees</strong>
              <button mat-icon-button color="primary" type="button" (click)="addOne('fee')">
                <i class="material-icons">add_circle_outline</i>
              </button>
            </div>
          </div>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <ng-container *ngFor="let fee of feesFormArray.controls; index as i">
          <div class="row" [formGroup]="fee" *ngIf="fee.value.source" >
            <div class="col-sm-4">
              <mat-form-field appearance="outline">
                <mat-label>Fee</mat-label>
                <mat-select  placeholder="Fee" formControlName="feeType">
                  <mat-option *ngFor="let type of feeTypes" [disabled]="fee.value.feeType !== type.id" [value]="type.id">{{type.text}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-sm-4">

              <mat-form-field appearance="outline" *ngIf="fee.value.feeType">
                <mat-label>Payment method</mat-label>
                <mat-select placeholder="Payment method" formControlName="feeDescription">
                  <mat-option *ngFor="let type of feeDescriptionTypes" [value]="type.id">{{type.text}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-sm-3">
              <mat-form-field appearance="outline"  class="text-end" *ngIf="fee.value.feeType">
                <mat-label>Amount</mat-label>
                <input matInput readonly matInputCommified placeholder="Amount" formControlName="feeAmount">
                <span matPrefix>$&nbsp;</span>
                <mat-error>
                  <ng-container *ngIf="fee.get('feeAmount').hasError('min')">Amount must be more than $1</ng-container>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-1">

            </div>
          </div>
        </ng-container>
        <ng-container *ngFor="let fee of feesFormArray.controls; index as i">
          <div class="row" [formGroup]="fee" *ngIf="!fee.value.source" >
            <div class="col-sm-4">
              <mat-form-field appearance="outline">
                <mat-label>Fee</mat-label>
                <mat-select (selectionChange)="handleFeeTypeChange(fee, $event.value); checkFeeValidation()" placeholder="Fee" formControlName="feeType">
                  <mat-option *ngFor="let type of feeTypes" [value]="type.id">{{type.text}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-sm-4">
              <mat-form-field appearance="outline" *ngIf="fee.value.feeType">
                <mat-label>Payment method</mat-label>
                <mat-select placeholder="Payment method" formControlName="feeDescription">
                  <ng-container *ngFor="let type of feeDescriptionTypes">
                    <mat-option
                    *ngIf="allowedPaymentMethods[fee.value.feeType]?.includes(type.id) || !allowedPaymentMethods[fee.value.feeType]"
                    [value]="type.id">{{type.text}}</mat-option>
                  </ng-container>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-sm-3">
              <mat-form-field appearance="outline" class="text-end" *ngIf="fee.value.feeType">
                <mat-label>Amount</mat-label>
                <input matInput matInputCommified placeholder="Amount" formControlName="feeAmount">
                <span matPrefix>$&nbsp;</span>
                <mat-error>
                  <ng-container *ngIf="fee.get('feeAmount').hasError('min')">Amount must be more than $1</ng-container>
                  <ng-container *ngIf="fee.get('feeAmount').hasError('max') && fee.value.maxValidationAmount">Amount must not be more than {{fee.value.maxValidationAmount}}</ng-container>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-1">
              <button mat-icon-button color="warn" class="button-absolute-right" type="button" (click)="removeOne('fee', i)">
                <i class="material-icons">remove_circle</i>
              </button>
            </div>
          </div>
        </ng-container>
        <div class="row">
          <div class="col-sm-3 offset-sm-8">
            <mat-form-field appearance="outline" class="text-end">
              <mat-label>Total fees paid from loan amount</mat-label>
              <input matInput matInputCommified placeholder="Total fees paid from loan amount" formControlName="feesFundedTotal" readonly>
              <span matPrefix>$&nbsp;</span>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-3 offset-sm-8">
            <mat-form-field appearance="outline" class="text-end">
              <mat-label>Total fees paid by the borrower</mat-label>
              <input matInput matInputCommified placeholder="Total fees paid by the borrower" formControlName="feesOtherTotal" readonly>
              <span matPrefix>$&nbsp;</span>
            </mat-form-field>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Deposits -->
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>
          <div class="row">
            <div class="col-sm-12">
              <strong>Deposits</strong>
              <button mat-icon-button color="primary" type="button" (click)="addOne('deposit')">
                <i class="material-icons">add_circle_outline</i>
              </button>
            </div>
          </div>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div *ngFor="let deposit of depositsFormArray.controls; index as i">
          <div class="row" [formGroup]="deposit">
            <div class="col-sm-4">
              <mat-form-field appearance="outline">
                <mat-label>Deposit type</mat-label>
                <mat-select placeholder="Deposit type" formControlName="depositType">
                  <mat-option *ngFor="let type of depositTypes" [value]="type.id">{{type.text}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-sm-4">
              <mat-form-field appearance="outline" *ngIf="deposit.value.depositType">
                <mat-label>Description</mat-label>
                <input matInput placeholder="Description" formControlName="depositDescription">
              </mat-form-field>
            </div>
            <div class="col-sm-3">
              <mat-form-field appearance="outline" class="text-end" *ngIf="deposit.value.depositType">
                <mat-label>Amount</mat-label>
                <input matInput matInputCommified placeholder="Amount" formControlName="depositAmount">
                <span matPrefix>$&nbsp;</span>
                <mat-error>
                  <ng-container *ngIf="deposit.get('depositAmount').hasError('min')">Amount must be more than $1</ng-container>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-1">
              <button mat-icon-button color="warn" type="button" (click)="removeOne('deposit', i)">
                <i class="material-icons">remove_circle</i>
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-3 offset-sm-8">
            <mat-form-field appearance="outline" class="text-end">
              <mat-label>Subtotal deposits</mat-label>
              <input matInput matInputCommified placeholder="Sub Total Deposits" formControlName="depositsTotal" readonly>
              <span matPrefix>$&nbsp;</span>
            </mat-form-field>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- splits -->
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>
          <div class="row">
            <div class="col-sm-12">
              <strong>Loan splits</strong>
              <p class="text-muted small mt-1" *ngIf="altDocProductFilterEnabled && isAltDocRequired">Based on the selected employment type or income verification method, only eligible products are displayed below.</p>
              <button mat-icon-button color="primary" type="button" (click)="addOne('split')">
                <i class="material-icons">add_circle_outline</i>
              </button>
            </div>
          </div>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div *ngFor="let split of splitsFormArray.controls; index as i;" [formGroup]="split">
            <div class="row" *ngIf="i === 0 && split.get('productPricing').valid">
              <div class="col-sm-3" *ngIf="loanTerms[i] && loanTerms[i].length > 0">
                <mat-form-field appearance="outline">
                  <mat-label>Loan Term</mat-label>
                  <mat-select placeholder="Loan Term" formControlName="term" (selectionChange)="syncLoanTerms(i, $event.value)">
                    <mat-option *ngFor="let loanTerm of loanTerms[i]" [value]="loanTerm.slug">{{loanTerm.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3">
                <mat-form-field appearance="outline">
                  <mat-label>Product</mat-label>
                  <mat-select panelClass="full-width" placeholder="Product" formControlName="productPricing" (selectionChange)="updateSelectedProduct($event.value, i)" [panelWidth]="null">
                    <mat-option *ngFor="let loan of loanProducts" [value]="loan.pricing.pricingSlug">{{loan.displayName}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="loanProducts.length === 0 && productsInitialized">
                    <ng-container *ngIf="!isSMSF">No Available Products</ng-container>
                    <ng-container *ngIf="isSMSF">No products available. Please check your security value and loan purpose to ensure you have the correct LVR.</ng-container>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-sm-2">
                <mat-form-field appearance="outline">
                  <mat-label>Rate</mat-label>
                  <input matInput matInputCommified placeholder="Rate" formControlName="rtb" readonly>
                  <span matSuffix>%</span>
                </mat-form-field>
              </div>
              <div class="col-sm-3">
                <mat-form-field appearance="outline" class="readonly-wrapper">
                  <mat-label>Repayment</mat-label>
                  <mat-select placeholder="Repayment" formControlName="repayment" (selectionChange)="setSplitTerm($event.value, i)">
                    <ng-container *ngFor="let type of repaymentTypes">
                      <mat-option
                      *ngIf="type.id === 'pi' && !(loanTermsIO[i] && loanTermsIO[i].length)
                      || (type.id === 'interest-only' && loanTermsIO[i] && loanTermsIO[i].length)"
                      [value]="type.id">{{type.text}}</mat-option>
                    </ng-container>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-sm-3">
                <mat-form-field appearance="outline" class="text-end">
                  <mat-label>Split amount</mat-label>
                  <input matInput matInputCommified placeholder="Split amount" formControlName="splitAmount">
                  <span matPrefix>$&nbsp;</span>
                  <mat-error>
                    <ng-container *ngIf="split.get('splitAmount').hasError('min')">Split amount is lower than the minimum allowed.</ng-container>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-sm-1">
                <button mat-icon-button color="warn" type="button" (click)="removeOne('split', i)">
                  <i class="material-icons">remove_circle</i>
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3" *ngIf="split.value.repayment === 'interest-only'">
                <mat-form-field appearance="outline" [ngClass]="{'readonly-wrapper': loanTermsIO[i]?.length === 1}">
                  <mat-label>IO Term</mat-label>
                  <mat-select placeholder="IO Term" formControlName="interestOnlyTerm">
                    <mat-option *ngFor="let loanTerm of loanTermsIO[i]" [value]="loanTerm.slug">{{loanTerm.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-sm-3" *ngIf="loanTermsFixed[i]?.length">
                <mat-form-field appearance="outline" [ngClass]="{'readonly-wrapper': loanTermsFixed[i]?.length === 1}">
                  <mat-label>Fixed rate term</mat-label>
                  <mat-select placeholder="Fixed Rate Term" formControlName="fixedRateTerm">
                    <mat-option *ngFor="let loanTerm of loanTermsFixed[i]" [value]="loanTerm.slug">{{loanTerm.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-sm-3" *ngIf="productHoneymoons[i]?.length">
                <mat-form-field appearance="outline" [ngClass]="{'readonly-wrapper': productHoneymoons[i]?.length === 1}">
                  <mat-label>Discount variable</mat-label>
                  <mat-select class="readonly-block" placeholder="Discount Variable" formControlName="honeymoon">
                    <mat-option *ngFor="let honeymoon of productHoneymoons[i]" [value]="honeymoon.slug">{{honeymoon.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row" *ngIf="splitWarnings[i]?.length > 0">
              <div *ngFor="let warning of splitWarnings[i]" class="col-sm-12 alert alert-warning" role="alert">
                <ng-container [ngSwitch]="warning.type">
                  <span *ngSwitchCase="'minLoan'">
                    Loan Amount ({{warning.data.loanAmount || 0 | currency}}) is less than the minimum allowed for this Product ({{warning.data.minLoan | currency}})
                  </span>
                  <span *ngSwitchCase="'maxLoan'">
                    Split Amount ({{warning.data.splitAmount || 0 | currency}}) is more than the maximum allowed for this Product ({{warning.data.maxLoan | currency}})
                  </span>
                  <span *ngSwitchCase="'minSplit'">
                    Split Amount ({{warning.data.splitAmount || 0 | currency}}) is less than the minimum allowed for this split ({{warning.data.minSplit | currency}})
                  </span>
               </ng-container>
              </div>
            </div>
            <hr/>
        </div>
        <div class="row">
          <div class="col-sm-3">

          </div>
          <div class="col-sm-3 offset-sm-2">
            <mat-form-field appearance="outline" class="text-end">
              <mat-label>Unallocated amount</mat-label>
              <input matInput matInputCommified placeholder="Unallocated amount" formControlName="unallocatedAmount" readonly>
              <span matPrefix>$&nbsp;</span>
              <mat-error>Please make sure all amounts are properly allocated.</mat-error>
            </mat-form-field>
          </div>
          <div class="col-sm-3">
            <mat-form-field appearance="outline" class="text-end">
              <mat-label>Total loan facility</mat-label>
              <input matInput matInputCommified placeholder="Total Loan Facility" formControlName="loanFacilityTotal" readonly>
              <span matPrefix>$&nbsp;</span>
              <mat-error>
                <ng-container *ngIf="formGroup.get('loanFacilityTotal').hasError('min')">Loan amount is lower than the minimum allowed.</ng-container>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </mat-card-content>
</mat-card>
